import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { fieldToUppercase } from '@shared/helpers';
import { Textarea } from '@shared/ui';
import { onChangeValidator } from 'library/helpers/events';
import { useCountries } from 'library/hooks/events';
import * as st from './styles.module.scss';

export const Address = (): JSX.Element => {
  const { control, register } = useFormContext();

  const { countries, status } = useCountries();

  return (
    <div className={st.address}>
      <div className={st.address__left}>
        {/* <Controller
          control={control}
          name="address.country"
          render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
            <FormControl fullWidth size="small">
              {status === 'loaded' && (
                <>
                  <InputLabel
                    id="country"
                    shrink
                    style={{ backgroundColor: '#fff', padding: '0 5px', zIndex: '1' }}
                    error={!!error}
                  >
                    Страна*
                  </InputLabel>
                  <Select
                    labelId="country"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    label="Страна"
                    input={<OutlinedInput error={!!error} />}
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.id} value={country.id}>
                        {country.title}
                      </MenuItem>
                    ))}
                  </Select>
                </>
              )}
            </FormControl>
          )}
        /> */}
        <Controller
          name="address.city"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
            <TextField
              className={st.city}
              label="Город/населенный пункт*"
              InputLabelProps={{ shrink: true }}
              value={value}
              onBlur={onBlur}
              onChange={(event) => {
                onChangeValidator(event, value, onChange);
              }}
              size="small"
              type="text"
              error={!!error}
            />
          )}
        />

        <Controller
          name="address.street"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
            <TextField
              className={st.street}
              label="Улица/проспект/переулок"
              InputLabelProps={{ shrink: true }}
              value={value}
              onBlur={onBlur}
              onChange={(event) => {
                onChangeValidator(event, value, onChange);
              }}
              size="small"
              type="text"
              error={!!error}
            />
          )}
        />
        <div className={st.houseOffice}>
          <Controller
            name="address.house"
            control={control}
            render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
              <TextField
                className={st.house}
                label="Дом №"
                InputLabelProps={{ shrink: true }}
                size="small"
                type="text"
                fullWidth
                value={value}
                onBlur={onBlur}
                onChange={(event) => {
                  onChangeValidator(event, value, onChange);
                }}
                error={!!error}
              />
            )}
          />

          <Controller
            name="address.office"
            control={control}
            render={({ field: { onChange, value, onBlur } }) => (
              <TextField
                className={st.office}
                label="Офис №"
                InputLabelProps={{ shrink: true }}
                value={value}
                onBlur={onBlur}
                onChange={(event) => {
                  onChangeValidator(event, value, onChange);
                }}
                size="small"
                type="text"
                fullWidth
              />
            )}
          />
        </div>
        {/* <div className={st.address__numbers}>
          <div className={st.left}>
            <Controller
              name="address.unit"
              control={control}
              render={({ field: { onChange, value, onBlur } }) => (
                <TextField
                  label="Корпус №"
                  InputLabelProps={{ shrink: true }}
                  value={value}
                  onBlur={onBlur}
                  onChange={(event) => {
                    onChangeValidator(event, value, onChange);
                  }}
                  type="text"
                  size="small"
                  fullWidth
                />
              )}
            />
          </div>
          <div className={st.right}>
            <Controller
              name="address.other"
              control={control}
              render={({ field: { onChange, value, onBlur } }) => (
                <TextField
                  label="Дополнительно"
                  InputLabelProps={{ shrink: true }}
                  value={value}
                  onBlur={onBlur}
                  onChange={(event) => {
                    onChangeValidator(event, value, onChange);
                  }}
                  type="text"
                  size="small"
                  fullWidth
                />
              )}
            />
          </div>
        </div>*/}
      </div>
      <div className={st.address__right}>
        <Controller
          name="address.description"
          control={control}
          render={({ fieldState: { error } }) => (
            <Textarea
              autosize
              label="Комментарий для клиента (как найти)"
              {...register(`address.description`, {
                onChange: (e) => (e.target.value = fieldToUppercase(e)),
              })}
              required={!!error}
            />
          )}
        />
      </div>
    </div>
  );
};
